import { PureComponent } from 'react';
import clsx from 'clsx';

interface Props {
  contextClassName?: string;
  modifierClassName?: string;
  text?: string;
  'data-testid'?: string;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
export default class Spinner extends PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    modifierClassName: 'Spinner--default',
  };

  render() {
    const { contextClassName, modifierClassName, text } = this.props;
    const className = clsx('Spinner', modifierClassName);

    return (
      <div className={contextClassName} data-testid={this.props['data-testid']}>
        <div className={className}>
          <div className="Spinner-body">
            <div className="Spinner-animation" />

            {text && <span className="Spinner-text">{text}</span>}
          </div>
        </div>
      </div>
    );
  }
}
